const usePermissionConfig = () => {
  return {
    /*
    * 创建开发者账号
    * 控制：创建开发者账号
    * 跳转路由名称：
    * */
    CREATE: 'OPS-AGL-KFZZHGL-CJKFZZH',
    /*
    * 编辑
    * 控制：编辑
    * 跳转路由名称：
    * */
    UPDATE: 'OPS-AGL-KFZZHGL-BJ',
    /*
    * 启用
    * 控制：启用
    * 跳转路由名称：
    * */
    ENABLE: 'OPS-AGL-KFZZHGL-QY',
    /*
    * 操作记录
    * 控制：操作记录
    * 跳转路由名称：
    * */
    LOG: 'OPS-AGL-KFZZHGL-CZJL',
    /*
    * 续费
    * 控制：续费
    * 跳转路由名称：
    * */
    RENEW: 'OPS-AGL-KFZZHGL-XF',
    /*
    * 创建APP
    * 控制：创建APP
    * 跳转路由名称：
    * */
    CREATEAPP: 'OPS-AGL-KFZZHGL-CJA',
    /*
    * 创建APP-编辑
    * 控制：创建APP-编辑
    * 跳转路由名称：
    * */
    UPDATEAPP: 'OPS-AGL-KFZZHGL-CJA-BJ',
    /*
    * 创建APP-启用停用
    * 控制：创建APP-启用停用
    * 跳转路由名称：
    * */
    ENABLEAPP: 'OPS-AGL-KFZZHGL-CJA-QYTY',
    /*
    * 创建APP-删除
    * 控制：创建APP-删除
    * 跳转路由名称：
    * */
    DELETEAPP: 'OPS-AGL-KFZZHGL-CJA-SC',
  };
};

export default usePermissionConfig;
